import { useMemo } from 'react';
import { useCoachPreferences } from './useCoachPreferences';
import { useCoachTeams } from './useCoachTeams';
import { useCurrentTeam } from './useCurrentTeam';

/**
 * Team id for coach-facing athlete UI (journey, profile summary).
 * Uses the coach's real team_members row when present; otherwise, when demo
 * content is enabled, uses the demo team id so new coaches see demo athletes
 * without creating a team first.
 *
 * Compliance / CARA code should keep using {@link useCurrentTeam} alone.
 */
export function useCoachEffectiveTeamId() {
  const { data: membership, isLoading: loadingMembership } = useCurrentTeam();
  const { preferences, isLoading: loadingPreferences } = useCoachPreferences();
  const { data: coachTeams = [], isLoading: loadingTeams } = useCoachTeams();

  const teamId = useMemo(() => {
    if (membership?.team_id) return membership.team_id;
    if (!preferences.showDemoContent) return null;
    const demo = coachTeams.find((m) => m.team?.is_demo === true);
    return demo?.team_id ?? null;
  }, [membership?.team_id, preferences.showDemoContent, coachTeams]);

  const isLoading = loadingMembership || loadingPreferences || loadingTeams;

  return { teamId, isLoading };
}
